// Polyfills for SSR

export const isSSR = typeof window === 'undefined'

export const HTMLElement = isSSR ? Object : window.HTMLElement
export const File = isSSR ? Object : window.File



//////////////////
// WEBPACK FOOTER
// ./node_modules/buefy/src/utils/ssr.js
// module id = nCGD
// module chunks = 0